import React, { useCallback } from 'react'
import SegmentedOptionsGroup, { SegmentedOptionsGroupOnValueChangeHandler } from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { setTourPriceMode } from 'actions/tour/TourV2Actions'
import { getTourPriceMode } from 'selectors/TourV2/toursSelectors'
import { useIntl } from 'react-intl'

function TourPriceToggle() {
  const tourPriceMode = useAppSelector(getTourPriceMode)
  const dispatch = useAppDispatch()
  const intl = useIntl()

  const handleChange = useCallback<SegmentedOptionsGroupOnValueChangeHandler>((newValue) => {
    dispatch(setTourPriceMode(newValue as 'total' | 'perDay'))
  }, [dispatch])

  return (<form>
    <SegmentedOptionsGroup
      inputsName="tourPriceMode"
      density="compact"
      onValueChange={handleChange}
    >
      <SegmentedOption
        checked={tourPriceMode === 'total'}
        value="total"
        title={intl.formatMessage({
          id: 'F0S88+WMY/',
          defaultMessage: 'Total price',
          description: 'Option label for total price display mode',
        })}
      />
      <SegmentedOption
        checked={tourPriceMode === 'perDay'}
        value="perDay"
        title={intl.formatMessage({
          id: '3vpmNVH+M8',
          defaultMessage: 'Price per day',
          description: 'Option label for price per day display mode',
        })}
      />
    </SegmentedOptionsGroup>
  </form>)
}

export default TourPriceToggle
